export default __webpack_public_path__ + "static/media/serviceImgHospital.88791f19.svg";